var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.528283 13.2872C0.814538 13.1203 1.18191 13.217 1.34884 13.5033C2.01033 14.6376 3.02161 15.4955 4.26871 16.0521C4.57131 16.1871 4.70713 16.5419 4.57208 16.8445C4.43702 17.1471 4.08223 17.2829 3.77963 17.1479C2.33042 16.5011 1.11458 15.4837 0.31222 14.1078C0.145293 13.8215 0.242028 13.4542 0.528283 13.2872Z",
    fill: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1219 2.13755C11.3107 1.30917 10.154 1.00361 9.02154 1.32584C8.70282 1.41652 8.37093 1.23167 8.28024 0.912949C8.18955 0.594229 8.37441 0.262339 8.69313 0.17165C10.2437 -0.269542 11.8568 0.151676 12.9793 1.298C13.2111 1.53477 13.2071 1.91465 12.9704 2.14648C12.7336 2.37832 12.3537 2.37432 12.1219 2.13755Z",
    fill: "#1C274C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94936 1.64671C5.77812 1.35305 5.27907 1.17496 4.77213 1.46468C4.26704 1.75334 4.17821 2.26217 4.34648 2.55072L6.367 6.01562C6.53393 6.30187 6.43719 6.66925 6.15094 6.83618C5.86468 7.0031 5.49731 6.90637 5.33038 6.62011L2.63635 2.00026C2.4651 1.70659 1.96605 1.5285 1.45911 1.81822C0.954029 2.10688 0.865196 2.61572 1.03346 2.90427L4.06425 8.10161C4.23118 8.38786 4.13444 8.75524 3.84819 8.92217C3.56193 9.0891 3.19456 8.99236 3.02763 8.70611L1.68061 6.39618C1.50937 6.10252 1.01032 5.92442 0.503376 6.21415C-0.00170693 6.50281 -0.0905403 7.01164 0.0777258 7.30019L3.10851 12.4975C4.39566 14.7048 7.57195 15.4211 10.2655 13.8817C12.9573 12.3433 13.9141 9.27015 12.6299 7.06799L10.6094 3.6031C10.4381 3.30944 9.9391 3.13134 9.43216 3.42107C8.92708 3.70973 8.83824 4.21856 9.00651 4.50711L10.3535 6.81704C10.4341 6.95529 10.4562 7.12001 10.4148 7.27459C10.3733 7.42918 10.2719 7.5608 10.1329 7.64021C8.89897 8.34544 8.5208 9.70906 9.06104 10.6355C9.22796 10.9217 9.13123 11.2891 8.84497 11.456C8.55872 11.623 8.19134 11.5262 8.02441 11.24C7.29424 9.98783 7.58927 8.48011 8.53238 7.41444C8.79604 7.11652 8.88633 6.68317 8.68592 6.3395L5.94936 1.64671Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandDisable);
export default __webpack_public_path__ + "static/media/stand-disable.e5e544b73243246c01fa94b834d3b57e.svg";
export { ForwardRef as ReactComponent };